import React from 'react';
import { Link } from 'react-router-dom';
import { Home, BookOpen, Search, AlertCircle } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#F5F5DC] pt-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <AlertCircle className="h-24 w-24 text-[#D4AF37] mx-auto mb-6" />

        <h1 className="text-6xl font-bold text-[#064635] mb-4">404</h1>

        <h2 className="text-3xl font-semibold text-[#064635] mb-4">
          This Page Doesn't Exist Yet
        </h2>

        <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
          The page you're looking for might have been moved, or perhaps it's still being added
          to our archive. Let us help you find what you're looking for.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          <Link
            to="/"
            className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-200
                     border-2 border-transparent hover:border-[#D4AF37] group"
          >
            <Home className="h-12 w-12 text-[#064635] mx-auto mb-3 group-hover:text-[#D4AF37] transition-colors" />
            <h3 className="text-lg font-semibold text-[#064635] mb-2">Go Home</h3>
            <p className="text-sm text-gray-600">
              Return to the homepage and start fresh
            </p>
          </Link>

          <Link
            to="/publications"
            className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-200
                     border-2 border-transparent hover:border-[#D4AF37] group"
          >
            <BookOpen className="h-12 w-12 text-[#064635] mx-auto mb-3 group-hover:text-[#D4AF37] transition-colors" />
            <h3 className="text-lg font-semibold text-[#064635] mb-2">Browse Publications</h3>
            <p className="text-sm text-gray-600">
              Explore our collection of scholarly works
            </p>
          </Link>

          <Link
            to="/search"
            className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-200
                     border-2 border-transparent hover:border-[#D4AF37] group"
          >
            <Search className="h-12 w-12 text-[#064635] mx-auto mb-3 group-hover:text-[#D4AF37] transition-colors" />
            <h3 className="text-lg font-semibold text-[#064635] mb-2">Search Archive</h3>
            <p className="text-sm text-gray-600">
              Find specific publications or topics
            </p>
          </Link>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-300">
          <p className="text-gray-600 mb-4">
            If you believe this page should exist, please let us know:
          </p>
          <Link
            to="/contact"
            className="inline-block bg-[#064635] text-white px-6 py-3 rounded-lg font-semibold
                     hover:bg-opacity-90 transition-colors duration-200"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
